import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31213cd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = {
  class: "flex-row-centered selection-form",
  style: {"align-items":"flex-end"}
}
const _hoisted_4 = { class: "flex-col-centered selection" }
const _hoisted_5 = { class: "center-buttons" }
const _hoisted_6 = { class: "container" }

import { ref, onMounted } from 'vue';
import { marketSelection } from "@/services/helpers/Helper";
import TablePersistentChecking, { ITableExpose } from '@/components/TablePersistentChecking.vue';
import MarketSelector from '@/components/MarketSelector.vue';
import ConfirmInterestPaymentPopUp from '@/components/Ledger/ConfirmInterestPaymentPopUp.vue';
import { interestPayments } from '@/services/network';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';
import IInterestPayment from '@/Interfaces/Ledgering/IInterestPayment';
import DbTableCsvHelper from '@/services/helpers/DbTableCsvHelper';
import useNotifier from '@/services/composables/Notifier';

const sortCol: keyof (IInterestPayment) = "interestPeriod";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmInterestPayments',
  setup(__props) {

const displayingForm = ref(false);
const displayedInterestPayments = ref<IInterestPayment[]>();
const cols: (keyof IInterestPayment)[] = [
    'transactionId',
    'receivedAccountType',
    'valueDate',
    'amount',
    'market',
    'currency',
    'interestPeriod',
    'accumulatedAccountType'
]
const labels: string[] = [
    'Transaction ID',
    'Account Interest Received',
    'Value Date',
    'Amount',
    'Market',
    'Currency',
    'Interest Period',
    'Account Interest Accumulated'
]
const defaultSortCols = [cols.findIndex(col =>col === sortCol)];
const defaultSortOrders: (1|-1)[] = [-1];
const table = ref<ITableExpose<IInterestPayment>>();

onMounted(async () => {
    document.title='Confirm Interest Payments - UV';
    marketSelection.value = 'GB';
    await getInterestPayments();
});

async function getInterestPayments() {
    try {
        displayedInterestPayments.value = undefined;
        const market = marketSelection.value;
        const res = await interestPayments.get({ market });
                displayedInterestPayments.value = res.data;
    } catch(error) {
        const name = __filename + "/" + getInterestPayments.name;
        const errorType = `Getting Interest Payment tables.`;
        useNotifierWithErrFormatter().error({
            name,
            errorType,
            error
        })
    }
}
function exportFilteredDisplayable() {
    const filtered = table.value?.GetFiltered() ?? [];
    if (filtered.length) {
        DbTableCsvHelper.generateCsvDownload(filtered, `InterestPayments.csv`);
    } else useNotifier().warn({ msg: 'There is nothing in the table to export.' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(MarketSelector, {
            onChange: getInterestPayments,
            enableSE: ""
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "incident-nav-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (displayingForm.value = !displayingForm.value))
              }, " Record Interest ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", { class: "utility-bar" }, [
          _createElementVNode("div", { class: "link-btn" }, [
            _createTextVNode(" ["),
            _createElementVNode("a", { onClick: exportFilteredDisplayable }, "Export csv"),
            _createTextVNode("] ")
          ])
        ]),
        _createVNode(TablePersistentChecking, {
          ref_key: "table",
          ref: table,
          id: "interestPaymentTable",
          Rows: displayedInterestPayments.value,
          Cols: cols,
          Labels: labels,
          DefaultSortCols: defaultSortCols,
          DefaultSortOrders: defaultSortOrders
        }, null, 8, ["Rows"])
      ])
    ]),
    _createVNode(ConfirmInterestPaymentPopUp, {
      modelValue: displayingForm.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayingForm).value = $event)),
      onConfirm: getInterestPayments
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})